import { unitInstanceFromStep } from '@cards/engine';
import { cardRef, cellTarget, defineGameCard, onAppear, planningTargets, targetStep, unitTarget, } from '../authoring/index.js';
export const ShieldBearerCard = defineGameCard({
    id: 'shield_bearer',
    gameplay: {
        type: 'UNIT',
        cost: 2,
        baseStats: { attack: 1, health: 4 },
        planning: planningTargets([
            // UNIT with authored steps owns its placement explicitly; without this
            // step the enumerator cannot produce a legal FIELD plan at all.
            targetStep('placement', cellTarget({
                side: 'ally',
                occupancy: 'empty',
                cardinality: { min: 1, max: 1 },
            })),
            targetStep('target', unitTarget({
                side: 'ally',
                cardTypes: ['UNIT'],
                cardinality: { min: 1, max: 1 },
            })),
        ]),
    },
    presentation: {
        name: 'Щитоносец',
        description: 'При раскрытии дайте выбранному союзному бойцу Щит 1.',
        glyph: {
            colors: ['#10213A', '#656470', '#3E4151', '#9D918C', '#73767F'],
            rows: [
                '.........11.........',
                '........1221........',
                '........2223........',
                '........2112........',
                '........4444........',
                '......11144111......',
                '.....1223113221.....',
                '....12114334112.....',
                '....134355552531....',
                '....112555555311....',
                '....145553355541....',
                '....1455345355431...',
                '....1455352355411...',
                '.....13553355311....',
                '.....1535555351.....',
                '......15333351......',
                '......13111131......',
                '......111..111......',
                '.....1331..1331.....',
                '.....1111..1111.....',
            ],
        },
    },
    role: 'playable',
    dependencies: [cardRef('shield_bearer')],
    abilities: [onAppear((ctx) => {
            const targetId = unitInstanceFromStep(ctx.plan?.selections ?? [], 'target');
            const target = targetId === undefined ? null : ctx.q.instance(targetId);
            if (ctx.self !== undefined && target?.zone === 'board'
                && target.controllerId === ctx.self.controllerId && ctx.q.cardType(target.id) === 'UNIT') {
                ctx.ops.addShield(ShieldBearerCard.id, target.id, 1, ctx.self.id);
            }
        }, { cause: 'played' })],
    ui: {
        mechanics: ['shield'],
        planning: {
            steps: {
                placement: { label: 'Выберите ячейку для Щитоносца' },
                target: { label: 'Выберите союзного бойца' },
            },
        },
    },
});
//# sourceMappingURL=shield_bearer.js.map